var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ValidationObserver',{ref:"observer"},[_vm._t("default",null,{"currentStep":_vm.step})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }